import { queryOptions } from '@tanstack/react-query';
import type { Pagination } from '@/common/pagination';
import type { SubAsset } from '@/common/sub-asset';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type SubAssetListSuccessResponseType = {
	subAssets: SubAsset[];
	total: number;
	limit: number;
	offset: number;
};

export type SubAssetListQueryFilterType = {
	assetId?: string;
	/** Only deleted sub-assets whose parent is live (needs SUB_ASSETS_DELETE) */
	deleted?: boolean;
};

export type SubAssetsQueryParams = SubAssetListQueryFilterType & Pagination;

export function getListSubAssetsOptions(assetId: string, query: SubAssetsQueryParams, enabled = true) {
	const extendedQuery = { ...query, assetId };
	return queryOptions({
		queryKey: ['assets', assetId, 'sub-assets', extendedQuery],
		queryFn: () => getListSubAssets(extendedQuery),
		enabled: enabled && !!assetId,
	});
}

async function getListSubAssets(query: SubAssetsQueryParams): Promise<SubAssetListSuccessResponseType | null> {
	const response = await axios.get(`${API_URLS.SUB_ASSETS.INDEX}`, {
		params: query,
	});
	return getResponse<SubAssetListSuccessResponseType>(response.data);
}
